import { MutationTree } from 'vuex';
import { State } from './state';
import { CalendarioMutationTypes } from './mutation-types';

export type Mutations<S = State> = {
  [CalendarioMutationTypes.SET_CONTEXTO](state: S, payload: Partial<State>): void;
};

const persistir = (state: State) => {
  sessionStorage.setItem('cal_ctx_ano', String(state.ano));
  sessionStorage.setItem('cal_ctx_calendarioId', String(state.calendarioId));
  sessionStorage.setItem('cal_ctx_ensinoId', String(state.ensinoId));
  sessionStorage.setItem('cal_ctx_descricao', state.descricaoCalendario);
  sessionStorage.setItem('cal_ctx_escopo', state.escopo);
};

export const mutations: MutationTree<State> & Mutations = {
  [CalendarioMutationTypes.SET_CONTEXTO](state: State, payload: Partial<State>) {
    Object.assign(state, payload);
    persistir(state);
  },
};
